import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import facilityService from '../../../services/apiServices/facilityService';
import { PhysicianActions } from 'src/redux/actions/constant';
import physicianService from 'src/services/apiServices/physician-service/physician-service';

const {
  GET_ALL_PATIENT_BY_ENTERPRISE_REQUEST,
  GET_ALL_PATIENT_BY_ENTERPRISE_SUCCESS,
  GET_ALL_PATIENT_BY_ENTERPRISE_FAILURE,
  GET_ALL_PATIENT_BY_ENTERPRISE_RESET,
  GET_ALL_PATIENT_BY_ENTERPRISE_LOADING,
} = PhysicianActions;

function* getAllPatient(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_ALL_PATIENT_BY_ENTERPRISE_LOADING });
    const response = yield call(physicianService.getAllPatient, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_ALL_PATIENT_BY_ENTERPRISE_SUCCESS, payload: response });
    } else {
      throw { ...response.data, statusCode: response?.status };
    }
  } catch (error) {
    yield put({ type: GET_ALL_PATIENT_BY_ENTERPRISE_FAILURE, payload: error });
  }
}

function* getAllPatientByEnterpriseSaga() {
  yield takeEvery(GET_ALL_PATIENT_BY_ENTERPRISE_REQUEST, getAllPatient);
}

export default getAllPatientByEnterpriseSaga;
